import * as React from 'react';
import { useSelector } from 'react-redux';
import {
  NewbuildingPushToCallBanner as BannerComponent,
  CallButton,
} from 'shared/components/NewbuildingPushToCallBanner';
import { trackPhoneOpen } from 'shared/containers/NewbuildingPushToCallBanner/tracking';
import { selectFullscreenGalleryOpened } from 'shared/selectors';
import { getDynamicCalltrackingSiteBlockId } from 'shared/selectors/getDynamicCalltrackingSiteBlockId';
import { getOffer, getOfferPhones } from 'shared/selectors/newObject';
import { getAgent } from 'shared/selectors/newObject/getAgent';
import { IPhoneSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';
import { getFormattedPhoneNumber } from 'shared/utils/formatters';
import { getCustomUrl } from 'shared/utils/tracking/getCustomUrl';

export const NewbuildingPushToCallBannerContainer = () => {
  const [isPhonesVisible, handlePhonesVisible] = React.useState(false);

  const offer = useSelector(getOffer);
  const phones = useSelector(getOfferPhones);
  const siteBlockId = useSelector(getDynamicCalltrackingSiteBlockId);
  const agent = useSelector(getAgent);
  const isFullscreen = useSelector(selectFullscreenGalleryOpened);

  const filteredPhones = React.useMemo(
    () => phones && phones.filter((phone: IPhoneSchema) => !!phone.number),
    [phones],
  );
  const phone = React.useMemo(() => (phones as IPhoneSchema[]).map(getFormattedPhoneNumber).join(', '), [phones]);

  const handleShowPhoneClick = React.useCallback(() => {
    handlePhonesVisible(true);

    const gaLabel = getCustomUrl(offer, agent);
    trackPhoneOpen(gaLabel);
  }, [offer, agent]);

  if (!filteredPhones || !filteredPhones.length) {
    return null;
  }

  return (
    <BannerComponent isFullscreen={isFullscreen}>
      <CallButton
        handleShowPhoneClick={handleShowPhoneClick}
        isPhonesVisible={isPhonesVisible}
        phone={phone}
        announcementId={offer.id}
        siteBlockId={siteBlockId}
      />
    </BannerComponent>
  );
};
